import { Badge } from '@/components/ui/badge';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { AppLink } from '@/components/ui/app-link';
import { IntegrationKind, getIntegrationKind } from './integration-kinds';
import { IntegrationRow, STATUS_BADGE_VARIANT } from './integration-rows';

type IntegrationPageHeaderProps = {
  kind: IntegrationKind;
  name: string;
  status: IntegrationRow['status'];
  actions?: ReactNode;
};

export function IntegrationPageHeader({ kind, name, status, actions }: IntegrationPageHeaderProps) {
  const definition = getIntegrationKind(kind);

  return (
    <div className="space-y-4">
      <AppLink
        to="/settings/integrations"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        All integrations
      </AppLink>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <img src={definition.logo} alt="" className="h-10 w-10 shrink-0 object-contain" />
          <div className="min-w-0">
            <h2 className="truncate text-xl font-medium">{name}</h2>
            <div className="flex items-center gap-2">
              <p className="text-sm text-muted-foreground">
                {definition.label} · {definition.scope === 'member' ? 'You' : 'Hub'}
              </p>
              <Badge variant={STATUS_BADGE_VARIANT[status.tone]}>{status.label}</Badge>
            </div>
          </div>
        </div>
        {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </div>
  );
}
